const getClientLogo = (client) => {
  const logo = client?.assets.find(asset => asset.type.type === 'logo')
  
  return logo ? logo.filename : null
}

export default getClientLogo